import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../../data/content';
import { SectionHeading } from '../SectionHeading';
import { CTAButton } from '../CTAButton';
export function Testimonials() {
  return <section className="bg-white px-4 py-16 sm:py-24" aria-labelledby="testimonials-title" data-id="element-269" data-mp="3mf7pufvy5mbi">
      <div className="mx-auto max-w-6xl" data-id="element-270" data-mp="3r8akkrcgn1ta">
        <SectionHeading eyebrow="Real feedback" title={<span id="testimonials-title" data-id="element-272" data-mp="68l3pt0uo5">What other Occupational Therapists are saying</span>} data-id="element-271" data-mp="17u624g4zk4" />

        <ul className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-273" data-mp="41rqx4l3y15q">
          {testimonials.map(t => <li key={t.name} className="flex flex-col rounded-3xl bg-cream p-6" data-id="element-274" data-mp="937bkvjdi5nl">
              <div className="flex gap-0.5 text-gold" aria-label="5 out of 5 stars" data-id="element-275" data-mp="e18rx8pezqvd">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-276" data-mp="2avdgm2pso4st" data-mpi={i} />)}
              </div>
              <h3 className="mt-4 font-serif text-xl font-bold leading-snug text-ink" data-id="element-277" data-mp="1sk9dcmcuqoe7">{t.headline}</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-ink/80" data-id="element-278" data-mp="1nu2mefuvarss">{t.body}</p>
              <div className="mt-auto flex items-center gap-3 pt-6" data-id="element-279" data-mp="1iupu3fl88sit">
                <img src={t.photo} alt={`Photo of ${t.name}`} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-white" loading="lazy" data-id="element-280" data-mp="1iuziwzujctmx" />
                <div data-id="element-281" data-mp="2bjn999u5697c">
                  <p className="font-bold text-ink" data-id="element-282" data-mp="2bi3vbpvyka8q">{t.name}</p>
                  <p className="text-sm text-muted" data-id="element-283" data-mp="26jsjj9m3rpnv">{t.role}</p>
                </div>
              </div>
            </li>)}
        </ul>

        <div className="mt-12" data-id="element-284" data-mp="22h5n0vehlgkc">
          <CTAButton label="I want to move my cases forward" data-id="element-285" data-mp="1xjm9xytiz9tz" />
        </div>
      </div>
    </section>;
}